import { Module } from '@nestjs/common';
import { ScheduleModule } from '@nestjs/schedule';
import { DemoCleanupService } from './demo-cleanup.service';

@Module({
  imports: [ScheduleModule.forRoot()],
  providers: [DemoCleanupService],
})
export class DemoCleanupModule {}
